var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_23227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 5.00065C12.1833 5.00065 14.0667 6.55065 14.4917 8.69232L14.7417 9.94232L16.0167 10.034C17.3167 10.1173 18.3333 11.209 18.3333 12.5007C18.3333 13.8757 17.2083 15.0007 15.8333 15.0007H5C3.15833 15.0007 1.66667 13.509 1.66667 11.6673C1.66667 9.95898 2.94167 8.53398 4.63333 8.35898L5.525 8.26732L5.94167 7.47565C6.73333 5.95065 8.28333 5.00065 10 5.00065ZM10 3.33398C7.59167 3.33398 5.5 4.70065 4.45833 6.70065C1.95 6.96732 0 9.09232 0 11.6673C0 14.4257 2.24167 16.6673 5 16.6673H15.8333C18.1333 16.6673 20 14.8007 20 12.5007C20 10.3007 18.2917 8.51732 16.125 8.36732C15.5583 5.49232 13.0333 3.33398 10 3.33398Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_23227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d679164868ea1ba8642ac673c071597a.svg";
export { ForwardRef as ReactComponent };